import InitializeLayout from '@js/layout';

import HomeManager from '@js/managers/homeManager';

InitializeLayout();

HomeManager.initialize();
